import { render, staticRenderFns } from "./ButtonSettings.vue?vue&type=template&id=3b01dffd"
import script from "./ButtonSettings.vue?vue&type=script&lang=js"
export * from "./ButtonSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports